export function ready(fn: () => any) {
    if (document.readyState !== 'loading') {
      fn();
      return;
    }
    document.addEventListener('DOMContentLoaded', fn);
}

export function formatPrice(p: Number): string {
    return p.toFixed(2);
}

export function formatNumber(p: Number): string {
    // Turn 12345 into 12'345
    const digits = p.toFixed(0).split("").reverse();

    let parts = [];
    for (let i = 0; i < digits.length; i += 3) {
        const chunk = digits.slice(i, i + 3);

        parts.unshift(chunk.reverse().join(""));
    }

    return parts.join("'")
}